import { useTranslations } from "next-intl";

import IconBin from "@/icons/icon-bin";
import Button from "~/components/common/button";

import Dialog from "../../common/dialog";
import Icon from "../../common/icon";
import styles from "../wishlist/wishlist.module.scss";

type Props = {
  isOpen?: boolean;
  onClose: () => void;
  onAfterOpen?: () => void;
  onAfterClose?: () => void;
  onSubmit: (data: boolean) => void;
};

export default function DeleteAddressDialog(props: Props) {
  const t = useTranslations();

  return (
    <Dialog
      isOpen={props.isOpen}
      title={
        <>
          <Icon icon={IconBin} />
          <span>{t("generic.myaccount.address.delete_address_title")}</span>
        </>
      }
      onClose={props.onClose}
      onAfterOpen={props.onAfterOpen}
      onAfterClose={props.onAfterClose}
      customStyles={styles}
    >
      <p>{t("generic.myaccount.address.delete_address_description")}</p>
      <Button variant="primary" type="button" onClick={() => props.onSubmit(true)}>
        {t("generic.myaccount.address.delete_address_confirm_cta")}
      </Button>
      <Button
        variant="secondary"
        type="button"
        onClick={() => {
          props.onSubmit(false);
          props.onClose();
        }}
      >
        {t("generic.myaccount.address.delete_address_cancel_cta")}
      </Button>
    </Dialog>
  );
}
